import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import { UrlStatement } from 'src/shared/model/http-model';
import { Observable } from 'rxjs';
import { HttpMethod } from 'src/shared/constants/http-method.enum';

@Injectable()
export class HttpCustomService {

  constructor(
    private httpClient: HttpClient) {
  }

  get(urlStatement: UrlStatement, options?: any, specialOptions?: any): Observable<any> {
    const params = this.createParams(options);
    return this.httpClient.get(this.bindUrlParams(urlStatement), {params, ...specialOptions});
  }

  post(urlStatement: UrlStatement, body?: any, options?: any): Observable<any> {
    return this.httpClient.post(this.bindUrlParams(urlStatement), body, options);
  }

  put(urlStatement: UrlStatement, body?: any, options?: any): Observable<any> {
    return this.httpClient.put(this.bindUrlParams(urlStatement), body);
  }

  delete(urlStatement: UrlStatement, options?: any): Observable<any> {
    return this.httpClient.delete(this.bindUrlParams(urlStatement), options);
  }

  patch(urlStatement: UrlStatement, body?: any, option?: any): Observable<any> {
    return this.httpClient.patch(this.bindUrlParams(urlStatement), body, option);
  }

  getList(urlStatement: UrlStatement, body: any, options?: any): Observable<any> {
    const params = this.createParams(options);
    return this.httpClient.post<any>(this.bindUrlParams(urlStatement), body, {params}).map(res => res);
  }

  request(method: HttpMethod, urlStatement: UrlStatement, body?: any, options?: any): Observable<any> {
    const builtOptions: any = {};
    if (body) {
      builtOptions.body = body;
    }
    if (options) {
      builtOptions.params = this.createParams(options);;
    }
    return this.httpClient.request(_.toString(method), this.bindUrlParams(urlStatement), builtOptions);
  }

  private createParams(options: any): HttpParams {
    let params = new HttpParams();
    if (options) {
      for (const key in options) {
        if (options.hasOwnProperty(key)) {
          // Append for multiple sorting
          if (_.isArray(options[key]) && _.size(options[key]) > 1) {
            const valueOps = options[key];
            for (const value in valueOps) {
              if (valueOps.hasOwnProperty(value)) {
                params = params.append(key, valueOps[value]);
              }
            }
          } else {
            params = params.set(key, options[key]);
          }
        }
      }
    }
    return params;
  }

  bindUrlParams(urlStatement: UrlStatement): string {
    return this.executeStatement(urlStatement);
  }

  private executeStatement(stmt: UrlStatement): string {
    let path = stmt.path;
    if (stmt.bind && stmt.values) {
      for (const key in stmt.bind) {
        const p = stmt.bind[key];
        const val = stmt.values[p.name];
        if (_.isNil(val)) {
          throw 'Not found a bind value : { name: ' + p.name + ' }';
        }
        path = _.replace(path, p.placeholder, _.toString(val));
      }
    }

    return path;
  }
}
